import { useEffect, useState } from "react";
import { Activity as ActivityIcon } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/admin/AdminUI";

export default function Activity() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/activity").then(({ data }) => setLogs(data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Journal d'activité" subtitle="Historique des actions importantes." />
      <Card className="p-2">
        {logs.length === 0 ? <EmptyState text="Aucune activité enregistrée." /> : (
          <div className="divide-y divide-[#1E293B]/60" data-testid="activity-list">
            {logs.map((l) => (
              <div key={l.id} className="flex items-start gap-3 p-4">
                <div className="w-9 h-9 rounded-xl bg-[#3B82F6]/15 grid place-items-center shrink-0"><ActivityIcon className="w-4 h-4 text-[#3B82F6]" /></div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-slate-200"><span className="font-semibold text-white">{l.actor}</span> {l.action}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{l.role && `${l.role} · `}{new Date(l.created_at).toLocaleString("fr-FR")}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
